{
  "title": "Modifier le membre du ménage",
  "client": "Client",
  "relationshipTo": "Relation avec {{whom}} (membre principal)",
  "continue": "Continuer",
  "updated": "Le membre du ménage {{memberName}} a été mis à jour.",
  "save": "Enregistrer",
  "accessType": "Autorisations"
}
